import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SalesPage } from './components/SalesPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { EarningsDisclaimer } from './pages/EarningsDisclaimer';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<SalesPage data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/terms" element={<TermsOfService data-id="element-7" />} data-id="element-6" />
        <Route path="/disclaimer" element={<EarningsDisclaimer data-id="element-9" />} data-id="element-8" />
      </Routes>
    </Router>;
}